<template>
  <div>
    <PageAllow controller="Campaigns" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="$consts.activitiesType"
          mobile-breakpoint="800"
          multi-sort
          class="elevation-2 px-4 pt-1 mt-5"
          :footer-props="$t('$config.footer-props')"
          hide-default-header
        >
          <template v-slot:item.actions="{ item }">
            <v-btn
              small
              color="primary"
              @click.stop="$router.push('/campaign/0?type=' + item.type)"
              class="px-2 me-2 mb-1"
            >
              {{ $t("Campaigns.action.choose") }}
            </v-btn>
          </template>
          <template v-slot:item.description="{ item }">
            <div class="my-2">
              {{ item.description }}
              <br />
              <span class="body-2 secondary--text">
                {{ item.template }}
              </span>
            </div>
          </template>
        </v-data-table>
      </div></v-sheet
    >
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import { mapState } from "vuex";

export default {
  data: () => ({}),

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialManagement"),
        disabled: false,
        href: "/materials",
      },
      {
        text: i18n.t("Nav.campaign"),
        disabled: false,
        href: "/campaign",
      },
      {
        text: i18n.t("Nav.activities"),
        disabled: false,
        href: "/campaign/select-type",
      },
      {
        text: i18n.t("Nav.selectType"),
        disabled: true,
        href: "",
      },
    ],

    headers: () => [
      {
        text: i18n.t("Campaigns.Fields.name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("Campaigns.description"),
        align: "start",
        sortable: false,
        value: "description",
      },
      {
        text: i18n.t("Campaigns.Fields.action"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["loading", "stickTableCols"]),
  },
  components: {
    PageAllow,
    Breadcrumbs,
  },
  methods: {},
  watch: {},
};
</script>

<style>
</style>